// import "@webcomponents/custom-elements"

import React from "react"
import ReactDOM from "react-dom"
import Cookies from "js-cookie"

import { init } from "@rematch/core/dist/umd/rematch"
import { Provider } from "react-redux"

import { q, qq } from "../../helper/q"
import * as models from "./models/index"
import RegionModal from "./componets/modal"

export const store = init({
  models,
  redux: {
    devtoolOptions: {
      name: "regions"
    }
  }
})

const Root = () => (
  <Provider store={store}>
    <RegionModal />
  </Provider>
)

if (window.frameCacheVars !== undefined) {
  BX.addCustomEvent("onFrameDataReceived", () => {
    // console.log("init with not frame")
    ReactDOM.render(<Root show={false} />, document.getElementById("modalRegion"))
    load()
  })
} else {
  BX.ready(function() {
    // console.log("init with BX.ready frame")
    ReactDOM.render(<Root show={false} />, document.getElementById("modalRegion"))
    load()
  })
}

// document.addEventListener("DOMContentLoaded", function() {
//   ReactDOM.render(<Root show={false} />, document.getElementById("modalRegion"))
// })

const load = () => {
  q(".buttonLocation").addEventListener("click", () => {
    store.dispatch.regions.open()
  })

  q(".locationChange").addEventListener("click", () => {
    store.dispatch.regions.open()
  })

  q(".buttonCityMobile").addEventListener("click", () => {
    store.dispatch.regions.open()
  })

  if (Cookies.get("regionask") !== "true") {
    q(".locationTooltip").classList.add("locationTooltipShow")
    q(".locationAccept").addEventListener("click", () => {
      Cookies.set("regionask", "true", {
        expires: 3600,
        path: "/"
      })
      q(".locationTooltip").classList.remove("locationTooltipShow")
    })
  }
}
